// dashboard
// assessments
// assign-role
// analytics
// report
// pricing
// settings
// seo - data
// email-template
// assessments / new
// open-new-position
// get-free-credits
// view-open-position
// payment-failure
// payment - success

const helpContent = {
  "/": {
    title: "Dashboard Page Help",
    points: [
      "The dashboard displays the total number of assessments you've sent. 'Completed' shows how many assessees have finished their assessments, while 'Incomplete' indicates those still pending.",
      "It also shows the number of open positions you've created, along with the count of positions that have been closed.",
      "It also displays the site admin, site manager and reporting manager added by the account owner and by you.",
      "If you are the account owner, you can assign admin rights by simply adding an Site Admin user.",
      "Once you've added role-based users, their username and password credentials will be securely sent to the entered email address, allowing them to sign in.",
      "Site Admin users have the privilege to add organizational hierarchy, such as Site Managers and Reporting Managers.",
      "Site Manager users have the privilege to add Reporting Managers to the organizational hierarchy.",
      "You can add an Admin User directly from here, or use the 'Add Site Admin Users' tab in the left sidebar.",
      "You can add a Staff User directly from here, or navigate to the 'Add reporting manager' tab in the left sidebar.",
      "The dashboard displays your recent transaction details, including the payments you've made.",
      "If you’re a new user, you’ll receive 2 free credits in your account. Once these are used, you’ll need to purchase a new plan.",
      "Each assessment will deduct 1 credit from your balance."
    ],
  },
  "/student-dashboard": {
    title: "Dashboard Page Help",
    points: [
      "The dashboard displays the total number of assessments you've sent. 'Completed' shows how many assessees have finished their assessments, while 'Incomplete' indicates those still pending.",
      "The dashboard displays your recent transaction details, including the payments you've made.",
      "Each assessment will deduct 1 credit from your balance."
    ],
  },

  "/assessments": {
    title: "Employee Assessments Help",
    points: [
      "Welcome to the assessment section! Here, you'll find the 'SelfSync Personality Assessment,' which consists of 60 questions and takes approximately 45 minutes to complete.",
      "In Employee Assessments, there are two types: New Hires and Existing Employee. Simply click on one to launch the assessment for your assessee.",
      "Select the type of assessment according to your requirement.",
      "If you choose New Hires, fill in the form with Email and Position Name.",
      "You can select from the suggested position names or create a new one that suits your needs.",
      "While adding emails, you can simply type an address like 'vedantroy@gmail.com' into the field and press Enter to add it. You can add multiple emails this way.",
      "Please double-check all email addresses before sending the assessment to ensure they are correct.",
      "If you choose 'Existing Employee', fill in the form with the employee's email, and ensure your account has a Reporting Manager assigned.",
      "For existing employees, once the assessment is sent, the assessee will need to select their Reporting Manager, who will then be able to view the generated report.",
      "Click the Submit button to send the assessment to the candidate.",
      "You can also upload bulk candidate emails using a CSV file.",
      "Instructions on how to use the CSV upload are provided in the 'How to Use' guide.",
      "If you're hiring on behalf of another company as a vendor, select the 'Hire as Vendor' section. You'll see a list of open positions shared by other companies on SelfSync.",
      "From there, choose a job role from the dropdown. Some positions will be fully open, while others are shared with you specifically by that company.",
      "Just select the appropriate role and enter the assessee’s email address to proceed.",
    ],
  },
  "/individual-assessment": {
    title: "Individual Assessments Help",
    points: [
      "Welcome to the assessment section! Here, you'll find the 'SelfSync Personality Assessment,' which consists of 60 questions and takes approximately 45 minutes to complete.",
      "In Employee Assessments, there are two types: Freshers and Existing Employee. Simply click on one to launch the assessment for yourself.",
      "Select the type of assessment according to your requirement.",
      "If you choose Freshers, fill in the form with Prefered Industry and Job Title.",
      "You can select from the suggested preferred industries or click on 'Others' and enter your preferred industry.",
      "While adding emails, you can simply type an address like 'vedantroy@gmail.com' into the field and press Enter to add it. You can add multiple emails this way.",
      "Please double-check all email addresses before sending the assessment to ensure they are correct.",
      "If you choose 'Existing Employee', fill in the form with the employee's email.",
      "Click the Submit button to send the assessment to the candidate.",
    ],
  },
  "/assessment-history": {
    title: "Assessment History Help",
    points: [
      "In this section, you can view the complete history of all assessments that have been sent, along with how your available credits have been utilized.",
      "Each assessment card displays key details such as the recipient's email and the date it was sent.",
      "Click on any card to view all assessments sent by that specific HR or reporting manager.",
    ]

  },

  "/report": {
    title: "Assessment Result Help",
    points: [
      "All conducted assessment results are displayed here.",
      // "There are two types of reports you can view:",
      // "1. Your own conducted assessment results.",
      // "2. Vendor-conducted assessment results.",
      "You can view the details about each assessment, including the assessment date and candidate name.",
      "You can also check the status of the sent assessment. If the report has been generated, a 'View Report' button will appear.",
      "Click on 'View Report' to view the complete assessment report of the assessee.",
      "Once you send an assessment to an assesse, if they do not attempt it within 3 hours, a 'Notify' button will appear next to the Report Status field.",
      "This button allows you to send a one-time email reminder. After the notification is sent, the button will no longer appear — you can notify the assesse only once."
    ],
  },
  "/student-report": {
    title: "Assessment Result Help",
    points: [
      "All conducted assessment results are displayed here.",
      "You can view the details about each assessment, including the assessment date and candidate name.",
      "You can also check the status of the sent assessment. If the report has been generated, a 'View Report' button will appear.",
      "Click on 'View Report' to view the complete assessment report of the assessee.",
    ],
  },

  // "/hire-through-vendor": {
  //   title: "Hire Through Vendor Help",
  //   points: [
  //     "In the 'Hire Through Vendor' section, you can create a new job opening—such as 'Software Developer'—for any role you need to hire.",
  //     "To invite vendor, you must enter the vendor’s email address. Please ensure the vendor is already registered on SelfSync, as only associated accounts can access private positions.",
  //     "Please specify the number of positions required for the selected job title.",
  //     "Also, include a job description so others can view the role details clearly.",
  //     "Positions can now be shared by inviting vendors exclusively through email addresses registered with SelfSync.",
  //     "On the right side of the page, you can view the positions you’ve added.",
  //     "To deactivate or reactivate a position, simply click the check icon next to it.",
  //   ],
  // },
  // "/open-positions": {
  //   title: "Create Positions Help",
  //   points: [
  //     "To assign a position to New Hires in the Send Assessment section, you first need to create a new position for your company.",
  //     "Fill in the required fields below and click Open New Position to create a position.",
  //     "All created positions will be listed on the same page.",
  //     "Once a position is created, it will appear in the Enter Position dropdown under the New Hire section.",
  //     "You can deactivate a position after hiring someone for it by simply clicking the Deactivate button.",
  //   ],
  // },

  "/assign-role": {
    title: "Add Staff Users Help",
    points: [
      "Add Reporting Manager: Assign system roles to team members by email.",
      "To assign a new role, enter the following details:",
      "1. Email Address: Enter the user’s email.",
      "2. Full Name: Enter the user’s full name.",
      "3. Add Manager: Search for the manager by name or email.",
      "Add Executive: Assign system roles to team members by email.",
      "To assign a new role, enter the following details:",
      "1. Email Address: Enter the user’s email.",
      "2. Full Name: Enter the user’s full name.",
      "You can also see the added executive details in the team structure.",
    ],
  },

  "/hire-through-vendor": {
    title: "View Shared Position Help",
    points: [
      "In the 'View Shared Positions' section, you can see only the job positions that have been shared with other companies.",
      "The 'View Shared Positions' section displays job positions you've created or that have been shared with you by others, along with their status (Active or Closed), job descriptions, and posting dates."
    ],
  },

  "/get-free-credits": {
    title: "Get Free Credits Help",
    points: [
      "When you share SelfSync.ai following these steps, you will receive bonus credits:",
      "1. Post a message on LinkedIn, Instagram, or Twitter.",
      "2. Tag @SelfSync.ai in your post (if applicable).",
      "3. Send a screenshot of your post to credits@selfsync.ai.",
      "4. Once verified, receive 3 bonus credits instantly!",
      "Offer Details:",
      "Get 2 assessment credits when you sign up for our free plan.",
      "Earn an additional 3 credits for sharing your experience!",
    ],
  },

  "/email-template": {
    title: "Email Template Help",
    points: [
      "Select an email template for existing employee to customize your message before sending the assessment.",
      "Choose the email template you want to use for your communication.",
      "All emails sent through our portal will follow the selected email template.",
    ],
  },

  "/add-admin": {
    title: "Add Site Admin / Site Manager Help",
    points: [
      "You can add account admins from here, who will be able to make payments on your behalf.",
      "Similarly, you can add Site Managers by simply entering their name and email address.",
      "Site Managers cannot make payments.",
      "Site Managers can add reporting managers.",
      "Once a role is assigned, the user's login credentials will be sent to their email, allowing them to sign in to the portal independently.",
      "You can remove a role by clicking the 'Remove' button.",
      "The list of added role-based users appears below.",
    ],
  },

  "/assign-role": {
    title: "Add Reporting Manager Help",
    points: [
      "You can add Reporting Managers by simply entering their name and email address ",
      "Once a role is assigned, the user's login credentials will be sent to their email, allowing them to sign in to the portal independently.",
      "You can remove a role by clicking the 'Remove' button.",
      "The Reporting Managers you add here will be available for selection when you send an assessment to an existing employee. The assessee will choose their Reporting Manager before submitting the assessment."
    ],
  },

  "/settings": {
    title: "My Profile Help",
    points: [
      "In 'My Profile', you can view and update your personal details whenever needed.",
      "You can also check your subscription details here.",
      "Add email addresses to send notifications and keep your team members informed.",
    ],
  },

  "/seo-data": {
    title: "Waitlist Registrations Help",
    points: [
      "In 'Waitlist Registrations', you can view all registrants.",
      "You can see details like First Name, Last Name, Email, Company, Mobile, and the time when they sent the request.",
      "You also have the option to download the registration data in CSV format",
    ],
  },

  "/helpinfo": {
    title: "Help",
    points: [
      "In the Help section, you can find guidance and support for using the portal."
    ],
  },


  "/pricing": {
    title: "Pricing  Help",
    points: [
      "Explore various packages based on the number of assessments you need.",
      "Each plan offers increasing value as the number of assessments increases.",
      "All plans include detailed assessment reports and flexible, commitment-free usage.",
      "If you have any questions, feel free to contact our support team by clicking on 'Talk to Our Team'. Just drop your message, and we’ll get back to you within 12 hours."
    ],
  },
};

export default helpContent;
